import React from 'react';
import { motion } from 'framer-motion';

const ProjectsSection = () => {
  return (
    <section className="section" data-testid="projects-section">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          {/* Title */}
          <motion.div 
            className="md:col-span-4"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <span className="text-xs font-mono tracking-[0.2em] uppercase text-neutral-500">
              02
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight uppercase mt-4 text-white">
              Future Projects
            </h2>
          </motion.div>
          
          {/* Content */}
          <motion.div 
            className="md:col-span-8"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          >
            <p className="text-lg md:text-xl text-neutral-300 leading-relaxed" data-testid="projects-text">
              Several things are coming. We're not ready to talk about most of them yet — not because we're being coy, but because unfinished work doesn't get announced here.
            </p>
            <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mt-6">
              What we can tell you is this: we are building tools that will change how you think about cooking, travel, creativity, money, what AI can actually do for a real person living a real life and the new experiences that it could bring. Some of them will surprise you. All of them are built on the same founding belief.
            </p>
            <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mt-6">
              AI isn't a luxury. It isn't a subscription trap. It isn't a tool for the few.
            </p>
            <p className="text-xl md:text-2xl text-white font-semibold mt-6">
              It is for everyone. And we intend to prove it.
            </p>
            <p className="text-lg md:text-xl text-neutral-400 leading-relaxed mt-6 italic">
              When the time is right, you'll hear about it here first.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
